import styled, { css } from 'styled-components'

export const Container = styled.article.attrs({
    className: 'card'
})`
	padding: 30px;
	border-radius: 12px;
	margin: 8px;
	box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);

	${props => props.disabled && css`
		opacity: 0.7 !important;
		cursor: not-allowed;
	`}

	h1 {
		font-size: 22px;
		font-weight: 500;
	}

	@media(max-width: ${props => props.expandOffset}px) {
		&:not(.no-responsive) {
			margin: 30px 0;
			border-radius: unset;
			padding: 30px 15px;

			h1 {
				margin: 0 10px 20px;
			}
		}
	}
`
